module.exports = __webpack_public_path__ + "static/media/135_Ivywall2.bfddd9d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135_Ivywall2.jpg
// module id = 533
// module chunks = 0